import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Parcel10Kg: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.864 80.601L206.833 62.48 149.136 34 48.166 51.753 105.865 80.6z" fill="#FDDE84" />
    <path opacity=".4" d="M81.084 68.026l100.969-17.753-9.616-4.808-101.34 18.123 9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l-57.697-28.848v-53.26l57.697 28.85z" fill="#C39000" />
    <path opacity=".4" d="M81.084 68.026v19.972l-9.987-5.178V63.588l9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l100.969-18.493V62.478L105.864 80.602z" fill="#FCCE09" />
    <path d="M232.2 93.9c0-4-10-7.4-22-7.4s-22 3.4-22 7.4v28.7c0 4 10 7.4 22 7.4s22-3.4 22-7.4V93.9z" fill="#6D6D6D" />
    <path
      d="M232.2 122.5V93.8c0 1.8-1.9 3.5-5.3 4.8v28.7c3.4-1.2 5.3-3 5.3-4.8zM210 101.2c-12.2 0-22-3.4-22-7.4v28.7c0 4 10 7.4 22 7.4h3.5v-28.5c-.9-.2-2.2-.2-3.5-.2z"
      fill="#6D6D6D"
    />
    <path d="M210 101.3c12.15 0 22-3.313 22-7.4s-9.85-7.4-22-7.4-22 3.313-22 7.4 9.85 7.4 22 7.4z" fill="#C8C8C8" />
    <path
      opacity=".05"
      d="M210 95.9c5.247 0 9.5-1.388 9.5-3.1 0-1.712-4.253-3.1-9.5-3.1s-9.5 1.388-9.5 3.1c0 1.712 4.253 3.1 9.5 3.1z"
      fill="#000"
    />
    <path
      d="M212.7 93.1v-5.9c0-.5-1.2-.9-2.7-.9-1.5 0-2.7.4-2.7.9v5.7c0 .1.1.2.2.4.4.4 1.4.6 2.5.6.9 0 1.6-.1 2.1-.4.1 0 .1 0 .2-.1h.1s.1 0 .1-.1l.1-.1c.1 0 .1 0 .1-.1z"
      fill="#555"
    />
    <path
      d="M219.5 81.1c0-1.7-4.2-3.1-9.5-3.1-5.2 0-9.5 1.4-9.5 3.1v5.4c0 1.7 4.2 3.1 9.5 3.1 5.2 0 9.5-1.4 9.5-3.1v-5.4z"
      fill="#6D6D6D"
    />
    <path
      opacity=".1"
      d="M219.5 81.1c0-1.7-4.2-3.1-9.5-3.1-5.2 0-9.5 1.4-9.5 3.1v5.4c0 1.7 4.2 3.1 9.5 3.1 5.2 0 9.5-1.4 9.5-3.1v-5.4z"
      fill="#fff"
    />
    <path
      d="M219.5 86.5v-5.4c0 .7-.9 1.5-2.2 2v5.4c1.3-.5 2.2-1.2 2.2-2zM210 84.2c-5.2 0-9.5-1.4-9.5-3.1v5.4c0 1.7 4.2 3.1 9.5 3.1h1.5v-5.4H210z"
      fill="#6D6D6D"
    />
    <path
      d="M210 84.2c5.247 0 9.5-1.388 9.5-3.1 0-1.712-4.253-3.1-9.5-3.1s-9.5 1.388-9.5 3.1c0 1.712 4.253 3.1 9.5 3.1z"
      fill="#C8C8C8"
    />
    <path
      d="M207.6 116.4v-2.2h1.4v-5.4h-1.5v-2.2c1.6 0 2.4 0 4.1-.1v7.6c.6 0 .9 0 1.5-.1v2.2c-2.2.2-3.3.2-5.5.2zM218.6 115.8c-1.3.2-2.2-.1-2.8-.8-.6-.8-.9-1.9-.9-3.3v-.8c0-1.5.3-2.6.9-3.5.6-.9 1.5-1.4 2.8-1.7 1.3-.2 2.2-.1 2.7.6.6.7.8 1.7.8 3.2v.8c0 1.5-.3 2.7-.8 3.7-.5.9-1.4 1.6-2.7 1.8zm0-2.1c.4-.1.6-.3.8-.8.1-.4.2-1.1.2-2.1v-.6c0-1-.1-1.6-.2-2-.1-.4-.4-.5-.8-.4-.4.1-.6.3-.8.7-.2.4-.2 1.1-.2 2.1v.6c0 1 .1 1.6.2 2 .1.4.4.5.8.5zM209.6 125.3v-5.8c.6 0 .9 0 1.6-.1v2.3h.4c.5-.9.7-1.4 1.2-2.3.7 0 1.1-.1 1.8-.1-.7 1.2-1 1.8-1.7 3 .7 1.1 1.1 1.7 1.8 2.8-.8.1-1.1.1-1.9.2-.5-.9-.8-1.3-1.3-2.2h-.3v2.3c-.7-.2-1-.2-1.6-.1zM217.2 124.8c-.8.1-1.4-.1-1.8-.5-.4-.4-.6-1.1-.6-2v-.5c0-.6.1-1.1.3-1.6.2-.5.5-.8.9-1.1.4-.3.8-.4 1.3-.5.9-.1 1.5 0 1.9.5-.4.5-.5.7-.9 1.1-.1-.1-.3-.2-.5-.3h-.6c-.3.1-.6.2-.7.5-.1.3-.2.7-.2 1.2v.4c0 .5.1.9.2 1.1.1.2.4.3.7.3.3 0 .5-.2.6-.4.1-.2.2-.5.2-.8-.4.1-.6.1-.9.1v-1.2c1-.1 1.5-.2 2.5-.4v1.1c0 .8-.2 1.5-.6 2-.5.5-1 .9-1.8 1z"
      fill="#D3D1D1"
    />
    <path
      opacity=".2"
      d="M226.9 127.4s0-.2 0 0V98.7c-3.4 1.4-7.7 2.2-13.3 2.6v28.5c5.8-.2 9.9-1 13.3-2.4z"
      fill="#fff"
    />
  </SvgIcon>
)
